import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  HStack,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  VStack,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import emptyAnnouncement from "../../../img/emptyAnnouncement.svg";
import rarrow from "../../../img/rarrow.svg";
import speaker from "../../../img/speaker.svg";
import {
  IGetAnnouncement
} from "../../../models/trainee-course.model";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import trainerRoutes from "../routes";

const TrAnnouncement = () => {
  const [courseAnnouncements, setCourseAnnouncements] = useState<
    IGetAnnouncement[]
  >([]);
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const params = useParams();
  const course_id: any = params.course_id;
  const [loading, setLoading] = useState(true);
  const [sortType, setSortType] = useState("");

  const courseName: null | string = localStorage.getItem("courseName");
  const showSideNav = useBreakpointValue({ base: false, md:true, lg: true });

  const menuLinks = [
    {
      text: "Course Information",
      route: trainerRoutes.trainerCourses.CourseInformationLink(course_id),
      keywords: ["course-information"],
    },
    {
      text: "Announcements",
      route: trainerRoutes.trainerCourses.AnnouncementLink(course_id),
      keywords: ["announcement"],
    },
    {
      text: "My trainees",
      route: trainerRoutes.trainerCourses.TraineesLink(course_id),
      keywords: ["trainees", "my-attendance-list"],
    },
    {
      text: "Event Scheduler",
      route: trainerRoutes.trainerCourses.CalendarLink(course_id),
      keywords: ["calendar"],
    },
    {
      text: "Discussions",
      route: trainerRoutes.trainerCourses.DiscussionLink(course_id),
      keywords: ["discussion", "discussions"],
    },
    {
      text: "Assessments",
      route: trainerRoutes.trainerCourses.AssignmentsLink(course_id),
      keywords: ["assessments", "assignment"],
    },
    {
      text: "Results",
      route: trainerRoutes.trainerCourses.ResultLink(course_id),
      keywords: ["results", "result"],
    },
    {
      text: "Resources",
      route: trainerRoutes.trainerCourses.ResourcesLink(course_id),
      keywords: ["resource", "resources"],
    },
  ];

  const activeLink = (link: string, keywords: string[]) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (keywords.some((keyword) => location.pathname.includes(keyword))) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  useEffect(() => {
    if (course_id)
      trainercoursesService.getCourseAnnouncement(course_id).then((res) => {
        setCourseAnnouncements(res.data);
        setLoading(false);
      });
  }, [course_id, courseAnnouncements.length]);

  const sortRecentFirst = () => {
    setSortType("recent");
    setCourseAnnouncements(
      [...courseAnnouncements].sort((a: any, b: any) => {
        return b.created_at > a.created_at
          ? 1
          : b.created_at === a.created_at
          ? 0
          : -1;
      })
    );
    return courseAnnouncements;
  };

  const sortOldestFirst = () => {
    setSortType("oldest");
    setCourseAnnouncements(
      [...courseAnnouncements].sort((a: any, b: any) => {
        return a.created_at > b.created_at
          ? 1
          : a.created_at === b.created_at
          ? 0
          : -1;
      })
    );
    return courseAnnouncements;
  };

  return (
    <>
      <TrDashboardHeader />
      <Box
        bg="#F9F8F8"
        minHeight="100vh"
        width="auto"
        pt={"1.5rem"}
        pb={"2rem"}
        height={"auto"}
      >
        {!showSideNav && (
          <HStack
            overflowX="scroll"
            width={"100%"}
            height={"60px"}
            justifyContent={"space-around"}
            alignItems={"center"}
            fontSize={"13px"}
            padding={"0px 8px"}
            bg="white"
            className="scroll-hidden"
            mt="1.38rem"
            flex={"no-wrap"}
          >
            {menuLinks.map((link, index) => (
              <React.Fragment key={index}>
                <Link
                  onClick={() => navigate(link.route)}
                  cursor={"pointer"}
                  textAlign={"center"}
                  alignContent={"center"}
                  wordBreak={"keep-all"}
                  height={"60px"}
                  borderBottom={
                    activeLink(link.route, link.keywords).borderLeft
                  }
                  borderColor={
                    activeLink(link.route, link.keywords).borderColor
                  }
                  color={activeLink(link.route, link.keywords).textColor}
                >
                  {link.text}
                </Link>
                {index < menuLinks.length - 1 && (
                  <Divider orientation="vertical" height="70%" />
                )}
              </React.Fragment>
            ))}
          </HStack>
        )}
        <Flex width="90%" mx="auto" pt={["50px", "60px", "60px", "80px"]}>
          {showSideNav && <TrainerSidenav />}
          <VStack width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }}>
            <HStack width={"100%"} height={"2rem"}>
              <Text
                as="span"
                fontSize={["16px", "20px"]}
                isTruncated
                maxWidth={["180px", "200px", "350px", "500px"]}
              >
                {courseName && courseName.replaceAll(/"/g, "")}
              </Text>
              <Image src={rarrow} />
              <Text as="span" fontSize={["16px", "20px"]} color={"#616161"}>
                Announcements
              </Text>
            </HStack>
            <Box
              width={"100%"}
              mx="auto"
              padding={{
                lg: "2.5rem",
                md: "2rem",
                sm: "1.4rem",
                base: "1.4rem",
              }}
              bg="white"
            >
              <Flex justifyContent="space-between" alignItems="baseline">
                <Text
                  color="#1E1E1E"
                  fontSize={{
                    lg: "28px",
                    md: "20px",
                    sm: "18px",
                    base: "18px",
                  }}
                  pb="30px"
                  fontWeight="600"
                >
                  Announcements{" "}
                </Text>
                <Button
                  onClick={() =>
                    navigate(`/trainer/course/${course_id}/new-announcement`)
                  }
                  fontSize={{ lg: "12px", md: "11px", sm: "9x", base: "9px" }}
                  width={{
                    lg: "fit-content",
                    md: "fit-content",
                    sm: "6.3rem",
                    base: "6.3rem",
                  }}
                  p="7px"
                  borderRadius="2px"
                  colorScheme="red"
                  size="sm"
                  // variant="pri_btn"
                >
                  NEW ANNOUNCEMENT
                </Button>
              </Flex>
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontSize="16px" color="#E53E3E">
                  All ({courseAnnouncements.length})
                </Text>
                <HStack gap={"0.5rem"}>
                  <Menu>
                    <MenuButton
                      minWidth="5rem"
                      height={["35px"]}
                      fontSize={{
                        lg: "14px",
                        md: "13px",
                        sm: "13px",
                        base: "12px",
                      }}
                      sx={{
                        border: "1px solid #EC3337",
                        padding: "7px",
                        borderRadius: "2px",
                        backgroundColor: "white",
                        _hover: {
                          backgroundColor: "transparent",
                        },
                        _active: {
                          backgroundColor: "transparent",
                        },
                      }}
                      as={Button}
                      rightIcon={<ChevronDownIcon />}
                      backgroundColor={"transparent"}
                      borderColor={"#9E9E9E"}
                      borderRadius={"2px"}
                      borderWidth={"1px"}
                      // _hover={
                      //   borderColor: "transparent",
                      // }
                    >
                      {/* {sortType == "oldest"
                        ? "Oldest"
                        : sortType == "recent"
                        ? "Recent"
                        : "All"} */}
                        Sort By
                    </MenuButton>
                    <MenuList width="5rem">
                      <MenuItem
                        fontSize={{
                          lg: "14px",
                          md: "13px",
                          sm: "13px",
                          base: "12px",
                        }}
                        as={Button}
                        onClick={sortRecentFirst}
                      >
                        Recent First
                      </MenuItem>
                      <MenuItem
                        fontSize={{
                          lg: "14px",
                          md: "13px",
                          sm: "13px",
                          base: "12px",
                        }}
                        as={Button}
                        onClick={sortOldestFirst}
                      >
                        Oldest First
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </HStack>
              </Flex>
              <Box>
                {loading ? (
                  <Loading />
                ) : courseAnnouncements.length > 0 ? (
                  <Box mt="1.4rem" minHeight={"50vh"}>
                    {courseAnnouncements?.map(
                      (each: IGetAnnouncement, index: number) => (
                        <Flex
                          key={index}
                          cursor="pointer"
                          justifyContent="space-between"
                          flexDirection={{
                            lg: "row",
                            md: "row",
                            sm: "column",
                            base: "column",
                          }}
                          borderLeft="1px solid"
                          borderColor="#EC3337"
                          alignItems="center"
                          mb="30px"
                          padding={{
                            lg: "1rem",
                            md: "0.8rem",
                            sm: "0.6rem",
                            base: "0.5rem",
                          }}
                          boxShadow="base"
                          height="auto"
                          onClick={() =>
                            navigate(
                              trainerRoutes.trainerCourses.EachAnnouncementLink(
                                course_id,
                                each.id
                              )
                            )
                          }
                        >
                          <Flex
                            width={{
                              lg: "63%",
                              md: "70%",
                              sm: "90%",
                              base: "90%",
                            }}
                            alignItems="center"
                            mr="10px"
                            ml="25px"
                          >
                            <Image
                              src={speaker}
                              height="10%"
                              width="10%"
                              display={{
                                lg: "block",
                                md: "block",
                                sm: "none",
                                base: "none",
                              }}
                            />
                            <Box>
                              <Text
                                fontWeight="600"
                                color="#616161"
                                fontSize={{
                                  lg: "20px",
                                  md: "18px",
                                  sm: "14px",
                                  base: "14px",
                                }}
                              >
                                {each.title}
                              </Text>
                              <Text
                                fontWeight="400"
                                color=" #B9B9B9"
                                mt="5px"
                                mb="5px"
                                fontSize={{
                                  lg: "12px",
                                  md: "11px",
                                  sm: "10px",
                                  base: "10px",
                                }}
                              >
                                Posted by {each.user.name}
                              </Text>
                              <Text
                                fontSize={{
                                  lg: "14px",
                                  md: "13px",
                                  sm: "12px",
                                  base: "12px",
                                }}
                                fontWeight="400"
                                color=" #B9B9B9"
                              >
                                {each.description.slice(0, 150)}...
                              </Text>
                            </Box>
                          </Flex>
                          <Box
                            width={{
                              lg: "auto",
                              md: "auto",
                              sm: "90%",
                              base: "90%",
                            }}
                            padding={{
                              lg: "1rem",
                              md: "0.8rem",
                              sm: "0.6rem",
                              base: "0.5rem",
                            }}
                          >
                            <Text fontSize="12px" color="#616161">
                              Posted
                            </Text>
                            <Text color="#B9B9B9" fontSize="11px">
                              {moment(each.created_at).fromNow()}
                            </Text>
                          </Box>
                          {/* <Box fontSize='14px' color='#616161'>10/32</Box> */}
                        </Flex>
                      )
                    )}
                  </Box>
                ) : (
                  <Center width={"100%"} height={"100%"}>
                    <Flex
                      // mt="1.6rem"
                      height="50vh"
                      flexDirection="column"
                      justifyContent="center"
                      marginTop="1rem"
                      alignItems="center"
                      gap="0.5rem"
                      width={"100%"}
                    >
                      <Image
                        src={emptyAnnouncement}
                        alt="Empty announcement"
                        height={{
                          lg: "16rem",
                          md: "14rem",
                          sm: "13rem",
                          base: "12rem",
                        }}
                        width={{
                          lg: "16rem",
                          md: "14rem",
                          sm: "13rem",
                          base: "12rem",
                        }}
                        m="0 auto"
                      />
                      <Text
                        fontSize={{
                          lg: "36px",
                          md: "28px",
                          sm: "22px",
                          base: "18px",
                        }}
                        fontWeight="600"
                        textAlign="center"
                      >
                        No Announcements
                      </Text>
                      <Text
                        fontSize={{ lg: "16px", md: "12px", sm: "11px" }}
                        textAlign="center"
                      >
                        There are no announcements yet.
                      </Text>
                    </Flex>
                  </Center>
                )}
              </Box>
            </Box>
          </VStack>
        </Flex>
      </Box>
    </>
  );
};

export default TrAnnouncement;
